import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getConnectorConfigurationsQueryKey } from "ConnectorConfigurations/Api/Queries/useConnectorConfigurationsQuery";
import { deleteConnectorConfiguration } from "Infrastructure/Api/Api";

export function useDeleteConnectorConfigurationMutation() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (id: number) => deleteConnectorConfiguration(id),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [getConnectorConfigurationsQueryKey(0, 100)],
			});
		},
	});
}
